import React from 'react';
import { Typography } from '@worthy-npm/worthy-common-ui-components';
import { useAppSelector } from '../../app/hooks';
import { getSlot } from '../../slices/schedulingSlice';

function PickupTimeLabel() {
  const slot = useAppSelector(getSlot);
  if (!slot) {
    return <>Pickup time is not available</>;
  }
  const [, month, day] = slot.readyTimestamp.split('T')[0].split('-');
  return (
    <>
      Pickup timeframe
      {slot && (
        <Typography component="span" fontWeight="inherit" color="text.primary">
          -
          {' '}
          {month}
          /
          {day}
          ,
          {' '}
          {slot.timeText}
        </Typography>
      )}
    </>
  );
}

export default PickupTimeLabel;
